import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AppConfigService } from '../config/app-config.service';
import { AuthStore } from './auth.store';

/**
 * Agrega el bearer a las requests dirigidas a NUESTRO backend.
 *
 * Filtra por `apiBaseUrl`/`apiFailoverUrl` para NO filtrar el token a terceros
 * (CDN, tiles del mapa, telemetría externa). El backend es quien autoriza.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthStore);
  const config = inject(AppConfigService);

  const token = auth.accessToken();
  if (!token) return next(req);

  const cfg = config.config();
  const isOwnApi =
    req.url.startsWith(cfg.apiBaseUrl) ||
    (cfg.apiFailoverUrl ? req.url.startsWith(cfg.apiFailoverUrl) : false);

  if (!isOwnApi) return next(req);

  return next(
    req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
  );
};
